// TODO: Move `isUpdate` and `isCurrentVersionSafe` information to PlatformDetails
export const isUpdateAvailableSelector = (state) => state.getIn(['app', 'version', 'updateAvailable']);
export const isCurrentVersionSafeSelector = (state) => state.getIn(['app', 'version', 'isCurrentVersionSafe']);

// TODO: Remove this currentAppVersion selector. The same information is now stored in PlatformDetails
export const getCurrentAppVersion = (state) => state.getIn(['app', 'version', 'currentVersion']);
